import PropTypes from "prop-types"
import { Controller } from "react-hook-form"
import { Link } from "react-router-dom"

import { ImgWrapper, ProductImg, Text } from "areas/order/components"
import Checkbox from "components/ui/checkbox"

const ChooseItem = ({
  control,
  errors,
  formType,
  items,
  lineItems,
  numEligibleItems,
}) => {
  const name = `${formType}Items`

  return (
    <>
      {numEligibleItems > 0 && (
        <Text mb={2}>
          Please select the item(s) you would like to {formType}:
        </Text>
      )}
      <div className="tablet:mb-16 tablet:grid-cols-2 mb-24 grid grid-cols-1 gap-16">
        {lineItems.map((item) => (
          <Controller
            control={control}
            key={`choose-item-${item.id}`}
            name={name}
            render={({ field }) => (
              <Checkbox
                checked={items.includes(item.id)}
                className="gap-16"
                disabled={item.error_message || item.has_in_progress_rma}
                name={name}
                onChange={(checked) => {
                  if (checked) {
                    field.onChange([...items, item.id])
                  } else {
                    field.onChange(items.filter((i) => i != item.id))
                  }
                }}
              >
                <ImgWrapper flexShrink="0" width="150px">
                  <ProductImg alt={item.title} src={item.image_url} />
                </ImgWrapper>
                <div>
                  <Text fontWeight="500">{item.title}</Text>
                  {(item.error_message || item.has_in_progress_rma) && (
                    <>
                      {item.error_message && (
                        <Text color="error" fontWeight="500">
                          {item.error_message}
                        </Text>
                      )}
                      {item.has_in_progress_rma && (
                        <Text color="error" fontWeight="500">
                          Your item has an RMA (Return Merchandise
                          Authorization) already in progress.
                        </Text>
                      )}
                      <Text fontWeight="500">
                        Please contact customer service at{" "}
                        <Link
                          href={`tel:${sl.config.customer_service_toll_free}`}
                          rel="nofollow"
                        >
                          {sl.config.customer_service_toll_free}
                        </Link>{" "}
                        or{" "}
                        <Link
                          href={`mailto:${sl.config.customer_service_email}`}
                          rel="nofollow"
                        >
                          {sl.config.customer_service_email}
                        </Link>{" "}
                        for assistance.
                      </Text>
                    </>
                  )}
                </div>
              </Checkbox>
            )}
          />
        ))}
      </div>
      <p className="text-error text-12">{errors[name]}</p>
    </>
  )
}

ChooseItem.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  formType: PropTypes.string,
  items: PropTypes.array,
  lineItems: PropTypes.array,
  numEligibleItems: PropTypes.number,
}

export default ChooseItem
